import { render, staticRenderFns } from "./FotoUpload.vue?vue&type=template&id=660acfae&scoped=true&"
import script from "./FotoUpload.vue?vue&type=script&lang=js&"
export * from "./FotoUpload.vue?vue&type=script&lang=js&"
import style0 from "./FotoUpload.vue?vue&type=style&index=0&id=660acfae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660acfae",
  null
  
)

export default component.exports